import { updateLoadingVersion } from 'components/Graph/commands/updateLoadingVersion';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { emptyGraphData } from 'components/Graph/model/GraphData';
import { emptyCallbackHistory } from 'utils/history/CallbackHistory';
import { refreshDeviceExplorerEntities } from './refreshDeviceExplorerEntities';

export const loadEmptyGraph: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    cmdContext.updateState((draft) => {
      draft.firstLoading = false;
      draft.graph = emptyGraphData;
      draft.graphMetadata = null;
      draft.history = emptyCallbackHistory;
      draft.loading = 'LOADED';
      draft.overlay = null;
    });
    cmdContext.singletonControllers.abort('loadGraph');

    dispatch(updateLoadingVersion);
    dispatch(refreshDeviceExplorerEntities);
  };
